import React, { useState, useEffect, useRef, useCallback } from 'react';
import styles from './botoseguir.module.scss';
import Modal from './Modal';
import clsx from 'clsx';
import Enllac from 'components/3catinfo/Enllac';
import { hitAudiencies } from 'components/3catinfo/Audiencies/audiencies-datalayer';
import { useModal } from 'hooks/3catinfo/useModal';
import { useUser } from 'hooks/useUser';
import { useLaMevaLlista } from 'hooks/3catinfo/useLaMevaLlista';
import { useViewport } from 'hooks/3catinfo/useViewport';
import ModalContent from 'components/3catinfo/AreaUsuaris/ModalNoLogat';
import Icona from '../ui/Icona/Icona';
import useIsServiceEnabled from 'hooks/useIsServiceEnabled';

const BotoSeguir = ({ obreEsquerra, text, textHitAudiencies, id, tipologia, linkTipus, slug, estil, isItemNoti, enviaApi }) => {
    const isVrEnabled = useIsServiceEnabled('videos-recomanats');
    const isRmEnabled = useIsServiceEnabled('resume-media');
    const isSpmEnabled = isVrEnabled && isRmEnabled;

    const [showModal, setShowModal] = useState(false);
    const [hoverModal, setHoverModal] = useState(false);
    const [opensEsquerra, setOpensEsquerra] = useState(obreEsquerra);
    const hoverModalRef = useRef(hoverModal);
    const modalRef = useRef(null);
    const buttonRef = useRef(null);
    const [isTimeoutActive, setIsTimeoutActive] = useState(false);
    const { setModal } = useModal();
    const { isMobile } = useViewport();
    const { zoomNavigator } = useViewport();
    const route = {
        type: 'web_3catinfo_meu3catinfo'
    };

    const routeBoto = {
        slug: slug,
        type: linkTipus
    };

    const stylesOverlay = clsx({
        [styles.overlay]: !opensEsquerra,
        [styles.esquerra]: opensEsquerra,
        [styles.forMobile]: isMobile,
        [styles[estil]]: !!estil
    });

    const stylesEnllac = clsx({
        [styles.enllac]: true,
        [styles.ambZoom]: zoomNavigator > 3
    });

    const { isAuthenticated } = useUser();
    const { isALaMevaLlista, toggleSelection, toggleSelectionNoApi } = useLaMevaLlista();

    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
            if (modalRef.current) {
                clearTimeout(modalRef.current);
            }
        };
    }, []);

    useEffect(() => {
        hoverModalRef.current = hoverModal;
    }, [hoverModal]);

    let bookMarkActive = isALaMevaLlista(Number(id), tipologia);

    const stylesBotoSeguir = clsx({
        [styles.inLineSegueix]: true,
        [styles.senseBotoSeguir]: !isSpmEnabled,
        [styles.fonsTaronja]: bookMarkActive,
        [styles[estil]]: !!estil
    });

    const showModalNoLogat = (title) => {
        setModal(<ModalContent />, { className: styles.modal, title });
    };

    const trackAudiencies = (tipologia, text) => {
        const labels = {
            NOT_AUTOR: 'Autor',
            DTY_CATEGORY: 'Tema'
        };
        const label = labels[tipologia];
        if (label) {
            const extraData = {};
            if (tipologia === 'NOT_AUTOR') {
                extraData.autor = text;
            } else if (tipologia === 'DTY_CATEGORY') {
                extraData.temes = text;
            }
            hitAudiencies('scSeguir', {
                URL: window.location.href,
                pantallaFavorits: `${label}: ${text}`,
                ...extraData
            });
        }
    };
    const toggleModalHandler = useCallback(async () => {
        if (!isAuthenticated) {
            showModalNoLogat('Inicia sessió amb el teu compte 3Cat');
            return;
        }

        //Forçem el tooltip a l'esquerra o dreta si sobresurt del viewport
        const buttonRect = buttonRef.current?.getBoundingClientRect();
        const pixelsFromRight = buttonRect ? window.innerWidth - buttonRect.right : 0;
        const pixelsFromLeft = buttonRect.left;
        if (pixelsFromRight < 300) {
            setOpensEsquerra(true);
        } else if (pixelsFromLeft < 300) {
            setOpensEsquerra(false);
        }

        setShowModal(true);

        bookMarkActive = !bookMarkActive;
        if (enviaApi) {
            await toggleSelection(Number(id), tipologia);
        } else {
            await toggleSelectionNoApi(Number(id), tipologia);
        }

        setIsTimeoutActive(true);
        modalRef.current = setTimeout(() => {
            if (isMounted.current) {
                if (!hoverModalRef.current) {
                    setShowModal(false);
                }
                setIsTimeoutActive(false);
            }
        }, 2000);
    }, [isAuthenticated, id, tipologia, showModalNoLogat, toggleSelection]);

    const handleMouseOut = () => {
        if (!isTimeoutActive || hoverModal) {
            setShowModal(false);
        }
    };
    const elmTresCatinfo = <span className={styles.bold}>El meu 3CatInfo</span>;
    const textContent = (bookMarkActive, route) => {
        let textContent;
        if (hoverModal && bookMarkActive) {
            textContent = <>Elimina d&#39;{elmTresCatinfo}</>;
        } else if (hoverModal && !bookMarkActive) {
            textContent = <>Segueix el tema</>;
        } else if (!hoverModal && bookMarkActive) {
            textContent = (isItemNoti && isMobile && <>Tema afegit a&nbsp;{elmTresCatinfo}</>) || (
                <>S&#39;ha afegit a&nbsp;{elmTresCatinfo}</>
            );
        } else {
            textContent = <>S&#39;ha eliminat d&#39;{elmTresCatinfo}</>;
        }

        return textContent;
    };

    const textBoto = bookMarkActive ? text || 'Seguint' : text || 'Segueix';
    return (
        <div className={stylesBotoSeguir} ref={buttonRef} data-testid='boto-seguir'>
            {/* Si tenim link */}
            {routeBoto.slug && (
                <div className={styles.boto}>
                    <Enllac route={routeBoto} className={stylesEnllac}>
                        {textBoto}
                    </Enllac>
                    {isSpmEnabled && (
                        <button
                            className={styles.botoSeguir}
                            onClick={(e) => {
                                setHoverModal(false);
                                toggleModalHandler(id, tipologia);
                                if (bookMarkActive) trackAudiencies(tipologia, textHitAudiencies);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Escape') {
                                    setHoverModal(false);
                                    setShowModal(false);
                                }
                            }}
                            onMouseEnter={() => {
                                clearTimeout(modalRef.current);
                                setHoverModal(true);
                                setShowModal(true);
                            }}
                            onFocus={() => {
                                clearTimeout(modalRef.current);
                                setHoverModal(true);
                                setShowModal(true);
                            }}
                            onMouseLeave={handleMouseOut}
                            onBlur={handleMouseOut}
                            aria-label={bookMarkActive ? 'Seguint' : 'Segueix'}
                        >
                            <Icona
                                icona={bookMarkActive ? 'verificat' : 'mes'}
                                isBlanc={true}
                                inline={true}
                                className={styles.iconaSeguir}
                            />
                        </button>
                    )}
                </div>
            )}
            {/* Si no tenim link i tenim el boto activat */}
            {!routeBoto.slug && isSpmEnabled && (
                <button
                    className={styles.boto}
                    onClick={(event) => {
                        setHoverModal(false);
                        toggleModalHandler(id, tipologia);
                        if (bookMarkActive) trackAudiencies(tipologia, textHitAudiencies);
                    }}
                    aria-label={bookMarkActive ? 'Seguint' : 'Segueix'}
                    onMouseEnter={() => {
                        setHoverModal(true);
                        setShowModal(true);
                    }}
                    onFocus={() => {
                        setHoverModal(true);
                        setShowModal(true);
                    }}
                    onMouseLeave={() => {
                        setShowModal(false);
                        setHoverModal(false);
                    }}
                    onBlur={() => setShowModal(false)}
                >
                    <span className={styles.enllac}>{textBoto}</span>
                    <span className={styles.botoSeguir}>
                        <Icona
                            icona={bookMarkActive ? 'verificat' : 'mes'}
                            isBlanc={true}
                            inline={true}
                            className={styles.iconaSeguir}
                        />
                    </span>
                </button>
            )}
            <div ref={modalRef}>
                <Modal isOpen={showModal}>
                    {(isItemNoti || !(hoverModal && !bookMarkActive)) && enviaApi && (
                        <div className={stylesOverlay}>{textContent(bookMarkActive, route)}</div>
                    )}
                </Modal>
            </div>
        </div>
    );
};

BotoSeguir.defaultProps = {
    obreEsquerra: false,
    isItemNoti: false
};

export default React.memo(BotoSeguir);
